import { Badge, Box, Group, Stack, Text } from '@mantine/core';

const NumberCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Text>{rowData.numberFormatted}</Text>
            </Stack>
        </Box>
    );
};

const NumberColumn = () => ({
    accessorKey: 'numberFormatted',
    header: 'Number',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <NumberCell cell={cell} />,
});
export default NumberColumn;
